import FontSymbol from 'ol-ext/style/FontSymbol'

function loadFontAwesomeDefs(): void {
    FontSymbol.addDefs(
        {
            font: 'FontAwesome',
            name: 'FontAwesome',
            copyright: 'SIL OFL 1.1',
            prefix: 'fa',
        },
        {
            'fa-glass': '\uF000',
            'fa-music': '\uF001',
            'fa-search': '\uF002',
            'fa-envelope-o': '\uF003',
            'fa-heart': '\uF004',
            'fa-star': '\uF005',
            'fa-star-o': '\uF006',
            'fa-user': '\uF007',
            'fa-film': '\uF008',
            'fa-th-large': '\uF009',
            'fa-th': '\uF00A',
            'fa-th-list': '\uF00B',
            'fa-check': '\uF00C',
            'fa-remove': '\uF00D',
            'fa-close': '\uF00D',
            'fa-times': '\uF00D',
            'fa-search-plus': '\uF00E',
            'fa-search-minus': '\uF010',
            'fa-power-off': '\uF011',
            'fa-signal': '\uF012',
            'fa-gear': '\uF013',
            'fa-cog': '\uF013',
            'fa-trash-o': '\uF014',
            'fa-home': '\uF015',
            'fa-file-o': '\uF016',
            'fa-clock-o': '\uF017',
            'fa-road': '\uF018',
            'fa-download': '\uF019',
            'fa-arrow-circle-o-down': '\uF01A',
            'fa-arrow-circle-o-up': '\uF01B',
            'fa-inbox': '\uF01C',
            'fa-play-circle-o': '\uF01D',
            'fa-rotate-right': '\uF01E',
            'fa-repeat': '\uF01E',
            'fa-refresh': '\uF021',
            'fa-list-alt': '\uF022',
            'fa-lock': '\uF023',
            'fa-flag': '\uF024',
            'fa-headphones': '\uF025',
            'fa-volume-off': '\uF026',
            'fa-volume-down': '\uF027',
            'fa-volume-up': '\uF028',
            'fa-qrcode': '\uF029',
            'fa-barcode': '\uF02A',
            'fa-tag': '\uF02B',
            'fa-tags': '\uF02C',
            'fa-book': '\uF02D',
            'fa-bookmark': '\uF02E',
            'fa-print': '\uF02F',
            'fa-camera': '\uF030',
            'fa-font': '\uF031',
            'fa-bold': '\uF032',
            'fa-italic': '\uF033',
            'fa-text-height': '\uF034',
            'fa-text-width': '\uF035',
            'fa-align-left': '\uF036',
            'fa-align-center': '\uF037',
            'fa-align-right': '\uF038',
            'fa-align-justify': '\uF039',
            'fa-list': '\uF03A',
            'fa-dedent': '\uF03B',
            'fa-outdent': '\uF03B',
            'fa-indent': '\uF03C',
            'fa-video-camera': '\uF03D',
            'fa-photo': '\uF03E',
            'fa-image': '\uF03E',
            'fa-picture-o': '\uF03E',
            'fa-pencil': '\uF040',
            'fa-map-marker': '\uF041',
            'fa-adjust': '\uF042',
            'fa-tint': '\uF043',
            'fa-edit': '\uF044',
            'fa-pencil-square-o': '\uF044',
            'fa-share-square-o': '\uF045',
            'fa-check-square-o': '\uF046',
            'fa-arrows': '\uF047',
            'fa-step-backward': '\uF048',
            'fa-fast-backward': '\uF049',
            'fa-backward': '\uF04A',
            'fa-play': '\uF04B',
            'fa-pause': '\uF04C',
            'fa-stop': '\uF04D',
            'fa-forward': '\uF04E',
            'fa-fast-forward': '\uF050',
            'fa-step-forward': '\uF051',
            'fa-eject': '\uF052',
            'fa-chevron-left': '\uF053',
            'fa-chevron-right': '\uF054',
            'fa-plus-circle': '\uF055',
            'fa-minus-circle': '\uF056',
            'fa-times-circle': '\uF057',
            'fa-check-circle': '\uF058',
            'fa-question-circle': '\uF059',
            'fa-info-circle': '\uF05A',
            'fa-crosshairs': '\uF05B',
            'fa-times-circle-o': '\uF05C',
            'fa-check-circle-o': '\uF05D',
            'fa-ban': '\uF05E',
            'fa-arrow-left': '\uF060',
            'fa-arrow-right': '\uF061',
            'fa-arrow-up': '\uF062',
            'fa-arrow-down': '\uF063',
            'fa-mail-forward': '\uF064',
            'fa-share': '\uF064',
            'fa-expand': '\uF065',
            'fa-compress': '\uF066',
            'fa-plus': '\uF067',
            'fa-minus': '\uF068',
            'fa-asterisk': '\uF069',
            'fa-exclamation-circle': '\uF06A',
            'fa-gift': '\uF06B',
            'fa-leaf': '\uF06C',
            'fa-fire': '\uF06D',
            'fa-eye': '\uF06E',
            'fa-eye-slash': '\uF070',
            'fa-warning': '\uF071',
            'fa-exclamation-triangle': '\uF071',
            'fa-plane': '\uF072',
            'fa-calendar': '\uF073',
            'fa-random': '\uF074',
            'fa-comment': '\uF075',
            'fa-magnet': '\uF076',
            'fa-chevron-up': '\uF077',
            'fa-chevron-down': '\uF078',
            'fa-retweet': '\uF079',
            'fa-shopping-cart': '\uF07A',
            'fa-folder': '\uF07B',
            'fa-folder-open': '\uF07C',
            'fa-arrows-v': '\uF07D',
            'fa-arrows-h': '\uF07E',
            'fa-bar-t-o': '\uF080',
            'fa-bar-t': '\uF080',
            'fa-twitter-square': '\uF081',
            'fa-facebook-square': '\uF082',
            'fa-camera-retro': '\uF083',
            'fa-key': '\uF084',
            'fa-gears': '\uF085',
            'fa-cogs': '\uF085',
            'fa-comments': '\uF086',
            'fa-thumbs-o-up': '\uF087',
            'fa-thumbs-o-down': '\uF088',
            'fa-star-half': '\uF089',
            'fa-heart-o': '\uF08A',
            'fa-sign-out': '\uF08B',
            'fa-linkedin-square': '\uF08C',
            'fa-thumb-tack': '\uF08D',
            'fa-external-link': '\uF08E',
            'fa-sign-in': '\uF090',
            'fa-trophy': '\uF091',
            'fa-github-square': '\uF092',
            'fa-upload': '\uF093',
            'fa-lemon-o': '\uF094',
            'fa-phone': '\uF095',
            'fa-square-o': '\uF096',
            'fa-bookmark-o': '\uF097',
            'fa-phone-square': '\uF098',
            'fa-twitter': '\uF099',
            'fa-facebook-f': '\uF09A',
            'fa-facebook': '\uF09A',
            'fa-github': '\uF09B',
            'fa-unlock': '\uF09C',
            'fa-credit-card': '\uF09D',
            'fa-feed': '\uF09E',
            'fa-rss': '\uF09E',
            'fa-hdd-o': '\uF0A0',
            'fa-bullhorn': '\uF0A1',
            'fa-bell': '\uF0F3',
            'fa-certificate': '\uF0A3',
            'fa-hand-o-right': '\uF0A4',
            'fa-hand-o-left': '\uF0A5',
            'fa-hand-o-up': '\uF0A6',
            'fa-hand-o-down': '\uF0A7',
            'fa-arrow-circle-left': '\uF0A8',
            'fa-arrow-circle-right': '\uF0A9',
            'fa-arrow-circle-up': '\uF0AA',
            'fa-arrow-circle-down': '\uF0AB',
            'fa-globe': '\uF0AC',
            'fa-wrench': '\uF0AD',
            'fa-tasks': '\uF0AE',
            'fa-filter': '\uF0B0',
            'fa-briefcase': '\uF0B1',
            'fa-arrows-alt': '\uF0B2',
            'fa-group': '\uF0C0',
            'fa-users': '\uF0C0',
            'fa-chain': '\uF0C1',
            'fa-link': '\uF0C1',
            'fa-cloud': '\uF0C2',
            'fa-flask': '\uF0C3',
            'fa-cut': '\uF0C4',
            'fa-scissors': '\uF0C4',
            'fa-copy': '\uF0C5',
            'fa-files-o': '\uF0C5',
            'fa-paperclip': '\uF0C6',
            'fa-save': '\uF0C7',
            'fa-floppy-o': '\uF0C7',
            'fa-square': '\uF0C8',
            'fa-navicon': '\uF0C9',
            'fa-reorder': '\uF0C9',
            'fa-bars': '\uF0C9',
            'fa-list-ul': '\uF0CA',
            'fa-list-ol': '\uF0CB',
            'fa-strikethrough': '\uF0CC',
            'fa-underline': '\uF0CD',
            'fa-table': '\uF0CE',
            'fa-magic': '\uF0D0',
            'fa-truck': '\uF0D1',
            'fa-pinterest': '\uF0D2',
            'fa-pinterest-square': '\uF0D3',
            'fa-google-plus-square': '\uF0D4',
            'fa-google-plus': '\uF0D5',
            'fa-money': '\uF0D6',
            'fa-caret-down': '\uF0D7',
            'fa-caret-up': '\uF0D8',
            'fa-caret-left': '\uF0D9',
            'fa-caret-right': '\uF0DA',
            'fa-columns': '\uF0DB',
            'fa-unsorted': '\uF0DC',
            'fa-sort': '\uF0DC',
            'fa-sort-down': '\uF0DD',
            'fa-sort-desc': '\uF0DD',
            'fa-sort-up': '\uF0DE',
            'fa-sort-asc': '\uF0DE',
            'fa-envelope': '\uF0E0',
            'fa-linkedin': '\uF0E1',
            'fa-rotate-left': '\uF0E2',
            'fa-undo': '\uF0E2',
            'fa-legal': '\uF0E3',
            'fa-gavel': '\uF0E3',
            'fa-dashboard': '\uF0E4',
            'fa-tachometer': '\uF0E4',
            'fa-comment-o': '\uF0E5',
            'fa-comments-o': '\uF0E6',
            'fa-flash': '\uF0E7',
            'fa-bolt': '\uF0E7',
            'fa-sitemap': '\uF0E8',
            'fa-umbrella': '\uF0E9',
            'fa-paste': '\uF0EA',
            'fa-clipboard': '\uF0EA',
            'fa-lightbulb-o': '\uF0EB',
            'fa-exchange': '\uF0EC',
            'fa-cloud-download': '\uF0ED',
            'fa-cloud-upload': '\uF0EE',
            'fa-user-md': '\uF0F0',
            'fa-stethoscope': '\uF0F1',
            'fa-suitcase': '\uF0F2',
            'fa-bell-o': '\uF0A2',
            'fa-coffee': '\uF0F4',
            'fa-cutlery': '\uF0F5',
            'fa-file-text-o': '\uF0F6',
            'fa-building-o': '\uF0F7',
            'fa-hospital-o': '\uF0F8',
            'fa-ambulance': '\uF0F9',
            'fa-medkit': '\uF0FA',
            'fa-fighter-jet': '\uF0FB',
            'fa-beer': '\uF0FC',
            'fa-h-square': '\uF0FD',
            'fa-plus-square': '\uF0FE',
            'fa-angle-double-left': '\uF100',
            'fa-angle-double-right': '\uF101',
            'fa-angle-double-up': '\uF102',
            'fa-angle-double-down': '\uF103',
            'fa-angle-left': '\uF104',
            'fa-angle-right': '\uF105',
            'fa-angle-up': '\uF106',
            'fa-angle-down': '\uF107',
            'fa-desktop': '\uF108',
            'fa-laptop': '\uF109',
            'fa-tablet': '\uF10A',
            'fa-mobile-phone': '\uF10B',
            'fa-mobile': '\uF10B',
            'fa-circle-o': '\uF10C',
            'fa-quote-left': '\uF10D',
            'fa-quote-right': '\uF10E',
            'fa-spinner': '\uF110',
            'fa-circle': '\uF111',
            'fa-mail-reply': '\uF112',
            'fa-reply': '\uF112',
            'fa-github-alt': '\uF113',
            'fa-folder-o': '\uF114',
            'fa-folder-open-o': '\uF115',
            'fa-smile-o': '\uF118',
            'fa-frown-o': '\uF119',
            'fa-meh-o': '\uF11A',
            'fa-gamepad': '\uF11B',
            'fa-keyboard-o': '\uF11C',
            'fa-flag-o': '\uF11D',
            'fa-flag-checkered': '\uF11E',
            'fa-terminal': '\uF120',
            'fa-code': '\uF121',
            'fa-mail-reply-all': '\uF122',
            'fa-reply-all': '\uF122',
            'fa-star-half-empty': '\uF123',
            'fa-star-half-full': '\uF123',
            'fa-star-half-o': '\uF123',
            'fa-location-arrow': '\uF124',
            'fa-crop': '\uF125',
            'fa-code-fork': '\uF126',
            'fa-unlink': '\uF127',
            'fa-chain-broken': '\uF127',
            'fa-question': '\uF128',
            'fa-info': '\uF129',
            'fa-exclamation': '\uF12A',
            'fa-superscript': '\uF12B',
            'fa-subscript': '\uF12C',
            'fa-eraser': '\uF12D',
            'fa-puzzle-piece': '\uF12E',
            'fa-microphone': '\uF130',
            'fa-microphone-slash': '\uF131',
            'fa-shield': '\uF132',
            'fa-calendar-o': '\uF133',
            'fa-fire-extinguisher': '\uF134',
            'fa-rocket': '\uF135',
            'fa-maxcdn': '\uF136',
            'fa-chevron-circle-left': '\uF137',
            'fa-chevron-circle-right': '\uF138',
            'fa-chevron-circle-up': '\uF139',
            'fa-chevron-circle-down': '\uF13A',
            'fa-html5': '\uF13B',
            'fa-css3': '\uF13C',
            'fa-anchor': '\uF13D',
            'fa-unlock-alt': '\uF13E',
            'fa-bullseye': '\uF140',
            'fa-ellipsis-h': '\uF141',
            'fa-ellipsis-v': '\uF142',
            'fa-rss-square': '\uF143',
            'fa-play-circle': '\uF144',
            'fa-ticket': '\uF145',
            'fa-minus-square': '\uF146',
            'fa-minus-square-o': '\uF147',
            'fa-level-up': '\uF148',
            'fa-level-down': '\uF149',
            'fa-check-square': '\uF14A',
            'fa-pencil-square': '\uF14B',
            'fa-external-link-square': '\uF14C',
            'fa-share-square': '\uF14D',
            'fa-compass': '\uF14E',
            'fa-toggle-down': '\uF150',
            'fa-caret-square-o-down': '\uF150',
            'fa-toggle-up': '\uF151',
            'fa-caret-square-o-up': '\uF151',
            'fa-toggle-right': '\uF152',
            'fa-caret-square-o-right': '\uF152',
            'fa-euro': '\uF153',
            'fa-eur': '\uF153',
            'fa-gbp': '\uF154',
            'fa-dollar': '\uF155',
            'fa-usd': '\uF155',
            'fa-rupee': '\uF156',
            'fa-inr': '\uF156',
            'fa-cny': '\uF157',
            'fa-rmb': '\uF157',
            'fa-yen': '\uF157',
            'fa-jpy': '\uF157',
            'fa-ruble': '\uF158',
            'fa-rouble': '\uF158',
            'fa-rub': '\uF158',
            'fa-won': '\uF159',
            'fa-krw': '\uF159',
            'fa-bitcoin': '\uF15A',
            'fa-btc': '\uF15A',
            'fa-file': '\uF15B',
            'fa-file-text': '\uF15C',
            'fa-sort-alpha-asc': '\uF15D',
            'fa-sort-alpha-desc': '\uF15E',
            'fa-sort-amount-asc': '\uF160',
            'fa-sort-amount-desc': '\uF161',
            'fa-sort-numeric-asc': '\uF162',
            'fa-sort-numeric-desc': '\uF163',
            'fa-thumbs-up': '\uF164',
            'fa-thumbs-down': '\uF165',
            'fa-youtube-square': '\uF166',
            'fa-youtube': '\uF167',
            'fa-xing': '\uF168',
            'fa-xing-square': '\uF169',
            'fa-youtube-play': '\uF16A',
            'fa-dropbox': '\uF16B',
            'fa-stack-overflow': '\uF16C',
            'fa-instagram': '\uF16D',
            'fa-flickr': '\uF16E',
            'fa-adn': '\uF170',
            'fa-bitbucket': '\uF171',
            'fa-bitbucket-square': '\uF172',
            'fa-tumblr': '\uF173',
            'fa-tumblr-square': '\uF174',
            'fa-long-arrow-down': '\uF175',
            'fa-long-arrow-up': '\uF176',
            'fa-long-arrow-left': '\uF177',
            'fa-long-arrow-right': '\uF178',
            'fa-apple': '\uF179',
            'fa-windows': '\uF17A',
            'fa-android': '\uF17B',
            'fa-linux': '\uF17C',
            'fa-dribbble': '\uF17D',
            'fa-skype': '\uF17E',
            'fa-foursquare': '\uF180',
            'fa-trello': '\uF181',
            'fa-female': '\uF182',
            'fa-male': '\uF183',
            'fa-gittip': '\uF184',
            'fa-gratipay': '\uF184',
            'fa-sun-o': '\uF185',
            'fa-moon-o': '\uF186',
            'fa-archive': '\uF187',
            'fa-bug': '\uF188',
            'fa-vk': '\uF189',
            'fa-weibo': '\uF18A',
            'fa-renren': '\uF18B',
            'fa-pagelines': '\uF18C',
            'fa-stack-exchange': '\uF18D',
            'fa-arrow-circle-o-right': '\uF18E',
            'fa-arrow-circle-o-left': '\uF190',
            'fa-toggle-left': '\uF191',
            'fa-caret-square-o-left': '\uF191',
            'fa-dot-circle-o': '\uF192',
            'fa-wheelchair': '\uF193',
            'fa-vimeo-square': '\uF194',
            'fa-turkish-lira': '\uF195',
            'fa-try': '\uF195',
            'fa-plus-square-o': '\uF196',
            'fa-space-shuttle': '\uF197',
            'fa-slack': '\uF198',
            'fa-envelope-square': '\uF199',
            'fa-wordpress': '\uF19A',
            'fa-openid': '\uF19B',
            'fa-institution': '\uF19C',
            'fa-bank': '\uF19C',
            'fa-university': '\uF19C',
            'fa-mortar-board': '\uF19D',
            'fa-graduation-cap': '\uF19D',
            'fa-yahoo': '\uF19E',
            'fa-google': '\uF1A0',
            'fa-reddit': '\uF1A1',
            'fa-reddit-square': '\uF1A2',
            'fa-stumbleupon-circle': '\uF1A3',
            'fa-stumbleupon': '\uF1A4',
            'fa-delicious': '\uF1A5',
            'fa-digg': '\uF1A6',
            'fa-pied-piper': '\uF1A7',
            'fa-pied-piper-alt': '\uF1A8',
            'fa-drupal': '\uF1A9',
            'fa-joomla': '\uF1AA',
            'fa-language': '\uF1AB',
            'fa-fax': '\uF1AC',
            'fa-building': '\uF1AD',
            'fa-child': '\uF1AE',
            'fa-paw': '\uF1B0',
            'fa-spoon': '\uF1B1',
            'fa-cube': '\uF1B2',
            'fa-cubes': '\uF1B3',
            'fa-behance': '\uF1B4',
            'fa-behance-square': '\uF1B5',
            'fa-steam': '\uF1B6',
            'fa-steam-square': '\uF1B7',
            'fa-recycle': '\uF1B8',
            'fa-automobile': '\uF1B9',
            'fa-car': '\uF1B9',
            'fa-cab': '\uF1BA',
            'fa-taxi': '\uF1BA',
            'fa-tree': '\uF1BB',
            'fa-spotify': '\uF1BC',
            'fa-deviantart': '\uF1BD',
            'fa-soundcloud': '\uF1BE',
            'fa-database': '\uF1C0',
            'fa-file-pdf-o': '\uF1C1',
            'fa-file-word-o': '\uF1C2',
            'fa-file-excel-o': '\uF1C3',
            'fa-file-powerpoint-o': '\uF1C4',
            'fa-file-photo-o': '\uF1C5',
            'fa-file-picture-o': '\uF1C5',
            'fa-file-image-o': '\uF1C5',
            'fa-file-zip-o': '\uF1C6',
            'fa-file-archive-o': '\uF1C6',
            'fa-file-sound-o': '\uF1C7',
            'fa-file-audio-o': '\uF1C7',
            'fa-file-movie-o': '\uF1C8',
            'fa-file-video-o': '\uF1C8',
            'fa-file-code-o': '\uF1C9',
            'fa-vine': '\uF1CA',
            'fa-codepen': '\uF1CB',
            'fa-jsfiddle': '\uF1CC',
            'fa-life-bouy': '\uF1CD',
            'fa-life-buoy': '\uF1CD',
            'fa-life-saver': '\uF1CD',
            'fa-support': '\uF1CD',
            'fa-life-ring': '\uF1CD',
            'fa-circle-o-notch': '\uF1CE',
            'fa-ra': '\uF1D0',
            'fa-rebel': '\uF1D0',
            'fa-ge': '\uF1D1',
            'fa-empire': '\uF1D1',
            'fa-git-square': '\uF1D2',
            'fa-git': '\uF1D3',
            'fa-y-combinator-square': '\uF1D4',
            'fa-yc-square': '\uF1D4',
            'fa-hacker-news': '\uF1D4',
            'fa-tencent-weibo': '\uF1D5',
            'fa-qq': '\uF1D6',
            'fa-wechat': '\uF1D7',
            'fa-weixin': '\uF1D7',
            'fa-send': '\uF1D8',
            'fa-paper-plane': '\uF1D8',
            'fa-send-o': '\uF1D9',
            'fa-paper-plane-o': '\uF1D9',
            'fa-history': '\uF1DA',
            'fa-circle-thin': '\uF1DB',
            'fa-header': '\uF1DC',
            'fa-paragraph': '\uF1DD',
            'fa-sliders': '\uF1DE',
            'fa-share-alt': '\uF1E0',
            'fa-share-alt-square': '\uF1E1',
            'fa-bomb': '\uF1E2',
            'fa-soccer-ball-o': '\uF1E3',
            'fa-futbol-o': '\uF1E3',
            'fa-tty': '\uF1E4',
            'fa-binoculars': '\uF1E5',
            'fa-plug': '\uF1E6',
            'fa-slideshare': '\uF1E7',
            'fa-twitch': '\uF1E8',
            'fa-yelp': '\uF1E9',
            'fa-newspaper-o': '\uF1EA',
            'fa-wifi': '\uF1EB',
            'fa-calculator': '\uF1EC',
            'fa-paypal': '\uF1ED',
            'fa-google-wallet': '\uF1EE',
            'fa-cc-visa': '\uF1F0',
            'fa-cc-mastercard': '\uF1F1',
            'fa-cc-discover': '\uF1F2',
            'fa-cc-amex': '\uF1F3',
            'fa-cc-paypal': '\uF1F4',
            'fa-cc-stripe': '\uF1F5',
            'fa-bell-slash': '\uF1F6',
            'fa-bell-slash-o': '\uF1F7',
            'fa-trash': '\uF1F8',
            'fa-copyright': '\uF1F9',
            'fa-at': '\uF1FA',
            'fa-eyedropper': '\uF1FB',
            'fa-paint-brush': '\uF1FC',
            'fa-birthday-cake': '\uF1FD',
            'fa-area-t': '\uF1FE',
            'fa-pie-t': '\uF200',
            'fa-line-t': '\uF201',
            'fa-lastfm': '\uF202',
            'fa-lastfm-square': '\uF203',
            'fa-toggle-off': '\uF204',
            'fa-toggle-on': '\uF205',
            'fa-bicycle': '\uF206',
            'fa-bus': '\uF207',
            'fa-ioxhost': '\uF208',
            'fa-angellist': '\uF209',
            'fa-cc': '\uF20A',
            'fa-shekel': '\uF20B',
            'fa-sheqel': '\uF20B',
            'fa-ils': '\uF20B',
            'fa-meanpath': '\uF20C',
            'fa-buysellads': '\uF20D',
            'fa-connectdevelop': '\uF20E',
            'fa-dashcube': '\uF210',
            'fa-forumbee': '\uF211',
            'fa-leanpub': '\uF212',
            'fa-sellsy': '\uF213',
            'fa-shirtsinbulk': '\uF214',
            'fa-simplybuilt': '\uF215',
            'fa-skyatlas': '\uF216',
            'fa-cart-plus': '\uF217',
            'fa-cart-arrow-down': '\uF218',
            'fa-diamond': '\uF219',
            'fa-ship': '\uF21A',
            'fa-user-secret': '\uF21B',
            'fa-motorcycle': '\uF21C',
            'fa-street-view': '\uF21D',
            'fa-heartbeat': '\uF21E',
            'fa-venus': '\uF221',
            'fa-mars': '\uF222',
            'fa-mercury': '\uF223',
            'fa-intersex': '\uF224',
            'fa-transgender': '\uF224',
            'fa-transgender-alt': '\uF225',
            'fa-venus-double': '\uF226',
            'fa-mars-double': '\uF227',
            'fa-venus-mars': '\uF228',
            'fa-mars-stroke': '\uF229',
            'fa-mars-stroke-v': '\uF22A',
            'fa-mars-stroke-h': '\uF22B',
            'fa-neuter': '\uF22C',
            'fa-genderless': '\uF22D',
            'fa-facebook-official': '\uF230',
            'fa-pinterest-p': '\uF231',
            'fa-whatsapp': '\uF232',
            'fa-server': '\uF233',
            'fa-user-plus': '\uF234',
            'fa-user-times': '\uF235',
            'fa-hotel': '\uF236',
            'fa-bed': '\uF236',
            'fa-viacoin': '\uF237',
            'fa-train': '\uF238',
            'fa-subway': '\uF239',
            'fa-medium': '\uF23A',
            'fa-yc': '\uF23B',
            'fa-y-combinator': '\uF23B',
            'fa-optin-monster': '\uF23C',
            'fa-opencart': '\uF23D',
            'fa-expeditedssl': '\uF23E',
            'fa-battery-4': '\uF240',
            'fa-battery-full': '\uF240',
            'fa-battery-3': '\uF241',
            'fa-battery-three-quarters': '\uF241',
            'fa-battery-2': '\uF242',
            'fa-battery-half': '\uF242',
            'fa-battery-1': '\uF243',
            'fa-battery-quarter': '\uF243',
            'fa-battery-0': '\uF244',
            'fa-battery-empty': '\uF244',
            'fa-mouse-pointer': '\uF245',
            'fa-i-cursor': '\uF246',
            'fa-object-group': '\uF247',
            'fa-object-ungroup': '\uF248',
            'fa-sticky-note': '\uF249',
            'fa-sticky-note-o': '\uF24A',
            'fa-cc-jcb': '\uF24B',
            'fa-cc-diners-club': '\uF24C',
            'fa-clone': '\uF24D',
            'fa-balance-scale': '\uF24E',
            'fa-hourglass-o': '\uF250',
            'fa-hourglass-1': '\uF251',
            'fa-hourglass-start': '\uF251',
            'fa-hourglass-2': '\uF252',
            'fa-hourglass-half': '\uF252',
            'fa-hourglass-3': '\uF253',
            'fa-hourglass-end': '\uF253',
            'fa-hourglass': '\uF254',
            'fa-hand-grab-o': '\uF255',
            'fa-hand-rock-o': '\uF255',
            'fa-hand-stop-o': '\uF256',
            'fa-hand-paper-o': '\uF256',
            'fa-hand-scissors-o': '\uF257',
            'fa-hand-lizard-o': '\uF258',
            'fa-hand-spock-o': '\uF259',
            'fa-hand-pointer-o': '\uF25A',
            'fa-hand-peace-o': '\uF25B',
            'fa-trademark': '\uF25C',
            'fa-registered': '\uF25D',
            'fa-creative-commons': '\uF25E',
            'fa-gg': '\uF260',
            'fa-gg-circle': '\uF261',
            'fa-tripadvisor': '\uF262',
            'fa-odnoklassniki': '\uF263',
            'fa-odnoklassniki-square': '\uF264',
            'fa-get-pocket': '\uF265',
            'fa-wikipedia-w': '\uF266',
            'fa-safari': '\uF267',
            'fa-chrome': '\uF268',
            'fa-firefox': '\uF269',
            'fa-opera': '\uF26A',
            'fa-internet-explorer': '\uF26B',
            'fa-tv': '\uF26C',
            'fa-television': '\uF26C',
            'fa-contao': '\uF26D',
            'fa-500px': '\uF26E',
            'fa-amazon': '\uF270',
            'fa-calendar-plus-o': '\uF271',
            'fa-calendar-minus-o': '\uF272',
            'fa-calendar-times-o': '\uF273',
            'fa-calendar-check-o': '\uF274',
            'fa-industry': '\uF275',
            'fa-map-pin': '\uF276',
            'fa-map-signs': '\uF277',
            'fa-map-o': '\uF278',
            'fa-map': '\uF279',
            'fa-commenting': '\uF27A',
            'fa-commenting-o': '\uF27B',
            'fa-houzz': '\uF27C',
            'fa-vimeo': '\uF27D',
            'fa-black-tie': '\uF27E',
            'fa-fonticons': '\uF280',
        },
    )
}

function loadFontAwesome5Defs(): void {
    FontSymbol.addDefs({
        font: '"Font Awesome 5 Free"',
        name: 'FontAwesome5',
        copyright: 'SIL OFL 1.1',
        prefix: 'fa',
    }, {
        'fa-glass': '\uF000',
        'fa-music': '\uF001',
        'fa-search': '\uF002',
        'fa-envelope-o': '\uF003',
        'fa-heart': '\uF004',
        'fa-star': '\uF005',
        'fa-star-o': '\uF006',
        'fa-user': '\uF007',
        'fa-film': '\uF008',
        'fa-th-large': '\uF009',
        'fa-th': '\uF00A',
        'fa-th-list': '\uF00B',
        'fa-check': '\uF00C',
        'fa-remove': '\uF00D',
        'fa-close': '\uF00D',
        'fa-times': '\uF00D',
        'fa-search-plus': '\uF00E',
        'fa-search-minus': '\uF010',
        'fa-power-off': '\uF011',
        'fa-signal': '\uF012',
        'fa-gear': '\uF013',
        'fa-cog': '\uF013',
        'fa-trash-o': '\uF014',
        'fa-home': '\uF015',
        'fa-file-o': '\uF016',
        'fa-clock-o': '\uF017',
        'fa-road': '\uF018',
        'fa-download': '\uF019',
        'fa-arrow-circle-o-down': '\uF01A',
        'fa-arrow-circle-o-up': '\uF01B',
        'fa-inbox': '\uF01C',
        'fa-play-circle-o': '\uF01D',
        'fa-rotate-right': '\uF01E',
        'fa-repeat': '\uF01E',
        'fa-refresh': '\uF021',
        'fa-list-alt': '\uF022',
        'fa-lock': '\uF023',
        'fa-flag': '\uF024',
        'fa-headphones': '\uF025',
        'fa-volume-off': '\uF026',
        'fa-volume-down': '\uF027',
        'fa-volume-up': '\uF028',
        'fa-qrcode': '\uF029',
        'fa-barcode': '\uF02A',
        'fa-tag': '\uF02B',
        'fa-tags': '\uF02C',
        'fa-book': '\uF02D',
        'fa-bookmark': '\uF02E',
        'fa-print': '\uF02F',
        'fa-camera': '\uF030',
        'fa-font': '\uF031',
        'fa-bold': '\uF032',
        'fa-italic': '\uF033',
        'fa-text-height': '\uF034',
        'fa-text-width': '\uF035',
        'fa-align-left': '\uF036',
        'fa-align-center': '\uF037',
        'fa-align-right': '\uF038',
        'fa-align-justify': '\uF039',
        'fa-list': '\uF03A',
        'fa-dedent': '\uF03B',
        'fa-outdent': '\uF03B',
        'fa-indent': '\uF03C',
        'fa-video-camera': '\uF03D',
        'fa-photo': '\uF03E',
        'fa-image': '\uF03E',
        'fa-picture-o': '\uF03E',
        'fa-pencil': '\uF040',
        'fa-map-marker': '\uF041',
        'fa-adjust': '\uF042',
        'fa-tint': '\uF043',
        'fa-edit': '\uF044',
        'fa-pencil-square-o': '\uF044',
        'fa-share-square-o': '\uF045',
        'fa-check-square-o': '\uF046',
        'fa-arrows': '\uF047',
        'fa-step-backward': '\uF048',
        'fa-fast-backward': '\uF049',
        'fa-backward': '\uF04A',
        'fa-play': '\uF04B',
        'fa-pause': '\uF04C',
        'fa-stop': '\uF04D',
        'fa-forward': '\uF04E',
        'fa-fast-forward': '\uF050',
        'fa-step-forward': '\uF051',
        'fa-eject': '\uF052',
        'fa-chevron-left': '\uF053',
        'fa-chevron-right': '\uF054',
        'fa-plus-circle': '\uF055',
        'fa-minus-circle': '\uF056',
        'fa-times-circle': '\uF057',
        'fa-check-circle': '\uF058',
        'fa-question-circle': '\uF059',
        'fa-info-circle': '\uF05A',
        'fa-crosshairs': '\uF05B',
        'fa-times-circle-o': '\uF05C',
        'fa-check-circle-o': '\uF05D',
        'fa-ban': '\uF05E',
        'fa-arrow-left': '\uF060',
        'fa-arrow-right': '\uF061',
        'fa-arrow-up': '\uF062',
        'fa-arrow-down': '\uF063',
        'fa-mail-forward': '\uF064',
        'fa-share': '\uF064',
        'fa-expand': '\uF065',
        'fa-compress': '\uF066',
        'fa-plus': '\uF067',
        'fa-minus': '\uF068',
        'fa-asterisk': '\uF069',
        'fa-exclamation-circle': '\uF06A',
        'fa-gift': '\uF06B',
        'fa-leaf': '\uF06C',
        'fa-fire': '\uF06D',
        'fa-eye': '\uF06E',
        'fa-eye-slash': '\uF070',
        'fa-warning': '\uF071',
        'fa-exclamation-triangle': '\uF071',
        'fa-plane': '\uF072',
        'fa-calendar': '\uF073',
        'fa-random': '\uF074',
        'fa-comment': '\uF075',
        'fa-magnet': '\uF076',
        'fa-chevron-up': '\uF077',
        'fa-chevron-down': '\uF078',
        'fa-retweet': '\uF079',
        'fa-shopping-cart': '\uF07A',
        'fa-folder': '\uF07B',
        'fa-folder-open': '\uF07C',
        'fa-arrows-v': '\uF07D',
        'fa-arrows-h': '\uF07E',
        'fa-bar-t-o': '\uF080',
        'fa-bar-t': '\uF080',
        'fa-twitter-square': '\uF081',
        'fa-facebook-square': '\uF082',
        'fa-camera-retro': '\uF083',
        'fa-key': '\uF084',
        'fa-gears': '\uF085',
        'fa-cogs': '\uF085',
        'fa-comments': '\uF086',
        'fa-thumbs-o-up': '\uF087',
        'fa-thumbs-o-down': '\uF088',
        'fa-star-half': '\uF089',
        'fa-heart-o': '\uF08A',
        'fa-sign-out': '\uF08B',
        'fa-linkedin-square': '\uF08C',
        'fa-thumb-tack': '\uF08D',
        'fa-external-link': '\uF08E',
        'fa-sign-in': '\uF090',
        'fa-trophy': '\uF091',
        'fa-github-square': '\uF092',
        'fa-upload': '\uF093',
        'fa-lemon-o': '\uF094',
        'fa-phone': '\uF095',
        'fa-square-o': '\uF096',
        'fa-bookmark-o': '\uF097',
        'fa-phone-square': '\uF098',
        'fa-twitter': '\uF099',
        'fa-facebook-f': '\uF09A',
        'fa-facebook': '\uF09A',
        'fa-github': '\uF09B',
        'fa-unlock': '\uF09C',
        'fa-credit-card': '\uF09D',
        'fa-feed': '\uF09E',
        'fa-rss': '\uF09E',
        'fa-hdd-o': '\uF0A0',
        'fa-bullhorn': '\uF0A1',
        'fa-bell': '\uF0F3',
        'fa-certificate': '\uF0A3',
        'fa-hand-o-right': '\uF0A4',
        'fa-hand-o-left': '\uF0A5',
        'fa-hand-o-up': '\uF0A6',
        'fa-hand-o-down': '\uF0A7',
        'fa-arrow-circle-left': '\uF0A8',
        'fa-arrow-circle-right': '\uF0A9',
        'fa-arrow-circle-up': '\uF0AA',
        'fa-arrow-circle-down': '\uF0AB',
        'fa-globe': '\uF0AC',
        'fa-wrench': '\uF0AD',
        'fa-tasks': '\uF0AE',
        'fa-filter': '\uF0B0',
        'fa-briefcase': '\uF0B1',
        'fa-arrows-alt': '\uF0B2',
        'fa-group': '\uF0C0',
        'fa-users': '\uF0C0',
        'fa-chain': '\uF0C1',
        'fa-link': '\uF0C1',
        'fa-cloud': '\uF0C2',
        'fa-flask': '\uF0C3',
        'fa-cut': '\uF0C4',
        'fa-scissors': '\uF0C4',
        'fa-copy': '\uF0C5',
        'fa-files-o': '\uF0C5',
        'fa-paperclip': '\uF0C6',
        'fa-save': '\uF0C7',
        'fa-floppy-o': '\uF0C7',
        'fa-square': '\uF0C8',
        'fa-navicon': '\uF0C9',
        'fa-reorder': '\uF0C9',
        'fa-bars': '\uF0C9',
        'fa-list-ul': '\uF0CA',
        'fa-list-ol': '\uF0CB',
        'fa-strikethrough': '\uF0CC',
        'fa-underline': '\uF0CD',
        'fa-table': '\uF0CE',
        'fa-magic': '\uF0D0',
        'fa-truck': '\uF0D1',
        'fa-pinterest': '\uF0D2',
        'fa-pinterest-square': '\uF0D3',
        'fa-google-plus-square': '\uF0D4',
        'fa-google-plus': '\uF0D5',
        'fa-money': '\uF0D6',
        'fa-caret-down': '\uF0D7',
        'fa-caret-up': '\uF0D8',
        'fa-caret-left': '\uF0D9',
        'fa-caret-right': '\uF0DA',
        'fa-columns': '\uF0DB',
        'fa-unsorted': '\uF0DC',
        'fa-sort': '\uF0DC',
        'fa-sort-down': '\uF0DD',
        'fa-sort-desc': '\uF0DD',
        'fa-sort-up': '\uF0DE',
        'fa-sort-asc': '\uF0DE',
        'fa-envelope': '\uF0E0',
        'fa-linkedin': '\uF0E1',
        'fa-rotate-left': '\uF0E2',
        'fa-undo': '\uF0E2',
        'fa-legal': '\uF0E3',
        'fa-gavel': '\uF0E3',
        'fa-dashboard': '\uF0E4',
        'fa-tachometer': '\uF0E4',
        'fa-comment-o': '\uF0E5',
        'fa-comments-o': '\uF0E6',
        'fa-flash': '\uF0E7',
        'fa-bolt': '\uF0E7',
        'fa-sitemap': '\uF0E8',
        'fa-umbrella': '\uF0E9',
        'fa-paste': '\uF0EA',
        'fa-clipboard': '\uF0EA',
        'fa-lightbulb-o': '\uF0EB',
        'fa-exchange': '\uF0EC',
        'fa-cloud-download': '\uF0ED',
        'fa-cloud-upload': '\uF0EE',
        'fa-user-md': '\uF0F0',
        'fa-stethoscope': '\uF0F1',
        'fa-suitcase': '\uF0F2',
        'fa-bell-o': '\uF0A2',
        'fa-coffee': '\uF0F4',
        'fa-cutlery': '\uF0F5',
        'fa-file-text-o': '\uF0F6',
        'fa-building-o': '\uF0F7',
        'fa-hospital-o': '\uF0F8',
        'fa-ambulance': '\uF0F9',
        'fa-medkit': '\uF0FA',
        'fa-fighter-jet': '\uF0FB',
        'fa-beer': '\uF0FC',
        'fa-h-square': '\uF0FD',
        'fa-plus-square': '\uF0FE',
        'fa-angle-double-left': '\uF100',
        'fa-angle-double-right': '\uF101',
        'fa-angle-double-up': '\uF102',
        'fa-angle-double-down': '\uF103',
        'fa-angle-left': '\uF104',
        'fa-angle-right': '\uF105',
        'fa-angle-up': '\uF106',
        'fa-angle-down': '\uF107',
        'fa-desktop': '\uF108',
        'fa-laptop': '\uF109',
        'fa-tablet': '\uF10A',
        'fa-mobile-phone': '\uF10B',
        'fa-mobile': '\uF10B',
        'fa-circle-o': '\uF10C',
        'fa-quote-left': '\uF10D',
        'fa-quote-right': '\uF10E',
        'fa-spinner': '\uF110',
        'fa-circle': '\uF111',
        'fa-mail-reply': '\uF112',
        'fa-reply': '\uF112',
        'fa-github-alt': '\uF113',
        'fa-folder-o': '\uF114',
        'fa-folder-open-o': '\uF115',
        'fa-smile-o': '\uF118',
        'fa-frown-o': '\uF119',
        'fa-meh-o': '\uF11A',
        'fa-gamepad': '\uF11B',
        'fa-keyboard-o': '\uF11C',
        'fa-flag-o': '\uF11D',
        'fa-flag-checkered': '\uF11E',
        'fa-terminal': '\uF120',
        'fa-code': '\uF121',
        'fa-mail-reply-all': '\uF122',
        'fa-reply-all': '\uF122',
        'fa-star-half-empty': '\uF123',
        'fa-star-half-full': '\uF123',
        'fa-star-half-o': '\uF123',
        'fa-location-arrow': '\uF124',
        'fa-crop': '\uF125',
        'fa-code-fork': '\uF126',
        'fa-unlink': '\uF127',
        'fa-chain-broken': '\uF127',
        'fa-question': '\uF128',
        'fa-info': '\uF129',
        'fa-exclamation': '\uF12A',
        'fa-superscript': '\uF12B',
        'fa-subscript': '\uF12C',
        'fa-eraser': '\uF12D',
        'fa-puzzle-piece': '\uF12E',
        'fa-microphone': '\uF130',
        'fa-microphone-slash': '\uF131',
        'fa-shield': '\uF132',
        'fa-calendar-o': '\uF133',
        'fa-fire-extinguisher': '\uF134',
        'fa-rocket': '\uF135',
        'fa-maxcdn': '\uF136',
        'fa-chevron-circle-left': '\uF137',
        'fa-chevron-circle-right': '\uF138',
        'fa-chevron-circle-up': '\uF139',
        'fa-chevron-circle-down': '\uF13A',
        'fa-html5': '\uF13B',
        'fa-css3': '\uF13C',
        'fa-anchor': '\uF13D',
        'fa-unlock-alt': '\uF13E',
        'fa-bullseye': '\uF140',
        'fa-ellipsis-h': '\uF141',
        'fa-ellipsis-v': '\uF142',
        'fa-rss-square': '\uF143',
        'fa-play-circle': '\uF144',
        'fa-ticket': '\uF145',
        'fa-minus-square': '\uF146',
        'fa-minus-square-o': '\uF147',
        'fa-level-up': '\uF148',
        'fa-level-down': '\uF149',
        'fa-check-square': '\uF14A',
        'fa-pencil-square': '\uF14B',
        'fa-external-link-square': '\uF14C',
        'fa-share-square': '\uF14D',
        'fa-compass': '\uF14E',
        'fa-toggle-down': '\uF150',
        'fa-caret-square-o-down': '\uF150',
        'fa-toggle-up': '\uF151',
        'fa-caret-square-o-up': '\uF151',
        'fa-toggle-right': '\uF152',
        'fa-caret-square-o-right': '\uF152',
        'fa-euro': '\uF153',
        'fa-eur': '\uF153',
        'fa-gbp': '\uF154',
        'fa-dollar': '\uF155',
        'fa-usd': '\uF155',
        'fa-rupee': '\uF156',
        'fa-inr': '\uF156',
        'fa-cny': '\uF157',
        'fa-rmb': '\uF157',
        'fa-yen': '\uF157',
        'fa-jpy': '\uF157',
        'fa-ruble': '\uF158',
        'fa-rouble': '\uF158',
        'fa-rub': '\uF158',
        'fa-won': '\uF159',
        'fa-krw': '\uF159',
        'fa-bitcoin': '\uF15A',
        'fa-btc': '\uF15A',
        'fa-file': '\uF15B',
        'fa-file-text': '\uF15C',
        'fa-sort-alpha-asc': '\uF15D',
        'fa-sort-alpha-desc': '\uF15E',
        'fa-sort-amount-asc': '\uF160',
        'fa-sort-amount-desc': '\uF161',
        'fa-sort-numeric-asc': '\uF162',
        'fa-sort-numeric-desc': '\uF163',
        'fa-thumbs-up': '\uF164',
        'fa-thumbs-down': '\uF165',
        'fa-youtube-square': '\uF166',
        'fa-youtube': '\uF167',
        'fa-xing': '\uF168',
        'fa-xing-square': '\uF169',
        'fa-youtube-play': '\uF16A',
        'fa-dropbox': '\uF16B',
        'fa-stack-overflow': '\uF16C',
        'fa-instagram': '\uF16D',
        'fa-flickr': '\uF16E',
        'fa-adn': '\uF170',
        'fa-bitbucket': '\uF171',
        'fa-bitbucket-square': '\uF172',
        'fa-tumblr': '\uF173',
        'fa-tumblr-square': '\uF174',
        'fa-long-arrow-down': '\uF175',
        'fa-long-arrow-up': '\uF176',
        'fa-long-arrow-left': '\uF177',
        'fa-long-arrow-right': '\uF178',
        'fa-apple': '\uF179',
        'fa-windows': '\uF17A',
        'fa-android': '\uF17B',
        'fa-linux': '\uF17C',
        'fa-dribbble': '\uF17D',
        'fa-skype': '\uF17E',
        'fa-foursquare': '\uF180',
        'fa-trello': '\uF181',
        'fa-female': '\uF182',
        'fa-male': '\uF183',
        'fa-gittip': '\uF184',
        'fa-gratipay': '\uF184',
        'fa-sun-o': '\uF185',
        'fa-moon-o': '\uF186',
        'fa-archive': '\uF187',
        'fa-bug': '\uF188',
        'fa-vk': '\uF189',
        'fa-weibo': '\uF18A',
        'fa-renren': '\uF18B',
        'fa-pagelines': '\uF18C',
        'fa-stack-exchange': '\uF18D',
        'fa-arrow-circle-o-right': '\uF18E',
        'fa-arrow-circle-o-left': '\uF190',
        'fa-toggle-left': '\uF191',
        'fa-caret-square-o-left': '\uF191',
        'fa-dot-circle-o': '\uF192',
        'fa-wheelchair': '\uF193',
        'fa-vimeo-square': '\uF194',
        'fa-turkish-lira': '\uF195',
        'fa-try': '\uF195',
        'fa-plus-square-o': '\uF196',
        'fa-space-shuttle': '\uF197',
        'fa-slack': '\uF198',
        'fa-envelope-square': '\uF199',
        'fa-wordpress': '\uF19A',
        'fa-openid': '\uF19B',
        'fa-institution': '\uF19C',
        'fa-bank': '\uF19C',
        'fa-university': '\uF19C',
        'fa-mortar-board': '\uF19D',
        'fa-graduation-cap': '\uF19D',
        'fa-yahoo': '\uF19E',
        'fa-google': '\uF1A0',
        'fa-reddit': '\uF1A1',
        'fa-reddit-square': '\uF1A2',
        'fa-stumbleupon-circle': '\uF1A3',
        'fa-stumbleupon': '\uF1A4',
        'fa-delicious': '\uF1A5',
        'fa-digg': '\uF1A6',
        'fa-pied-piper': '\uF1A7',
        'fa-pied-piper-alt': '\uF1A8',
        'fa-drupal': '\uF1A9',
        'fa-joomla': '\uF1AA',
        'fa-language': '\uF1AB',
        'fa-fax': '\uF1AC',
        'fa-building': '\uF1AD',
        'fa-child': '\uF1AE',
        'fa-paw': '\uF1B0',
        'fa-spoon': '\uF1B1',
        'fa-cube': '\uF1B2',
        'fa-cubes': '\uF1B3',
        'fa-behance': '\uF1B4',
        'fa-behance-square': '\uF1B5',
        'fa-steam': '\uF1B6',
        'fa-steam-square': '\uF1B7',
        'fa-recycle': '\uF1B8',
        'fa-automobile': '\uF1B9',
        'fa-car': '\uF1B9',
        'fa-cab': '\uF1BA',
        'fa-taxi': '\uF1BA',
        'fa-tree': '\uF1BB',
        'fa-spotify': '\uF1BC',
        'fa-deviantart': '\uF1BD',
        'fa-soundcloud': '\uF1BE',
        'fa-database': '\uF1C0',
        'fa-file-pdf-o': '\uF1C1',
        'fa-file-word-o': '\uF1C2',
        'fa-file-excel-o': '\uF1C3',
        'fa-file-powerpoint-o': '\uF1C4',
        'fa-file-photo-o': '\uF1C5',
        'fa-file-picture-o': '\uF1C5',
        'fa-file-image-o': '\uF1C5',
        'fa-file-zip-o': '\uF1C6',
        'fa-file-archive-o': '\uF1C6',
        'fa-file-sound-o': '\uF1C7',
        'fa-file-audio-o': '\uF1C7',
        'fa-file-movie-o': '\uF1C8',
        'fa-file-video-o': '\uF1C8',
        'fa-file-code-o': '\uF1C9',
        'fa-vine': '\uF1CA',
        'fa-codepen': '\uF1CB',
        'fa-jsfiddle': '\uF1CC',
        'fa-life-bouy': '\uF1CD',
        'fa-life-buoy': '\uF1CD',
        'fa-life-saver': '\uF1CD',
        'fa-support': '\uF1CD',
        'fa-life-ring': '\uF1CD',
        'fa-circle-o-notch': '\uF1CE',
        'fa-ra': '\uF1D0',
        'fa-rebel': '\uF1D0',
        'fa-ge': '\uF1D1',
        'fa-empire': '\uF1D1',
        'fa-git-square': '\uF1D2',
        'fa-git': '\uF1D3',
        'fa-y-combinator-square': '\uF1D4',
        'fa-yc-square': '\uF1D4',
        'fa-hacker-news': '\uF1D4',
        'fa-tencent-weibo': '\uF1D5',
        'fa-qq': '\uF1D6',
        'fa-wechat': '\uF1D7',
        'fa-weixin': '\uF1D7',
        'fa-send': '\uF1D8',
        'fa-paper-plane': '\uF1D8',
        'fa-send-o': '\uF1D9',
        'fa-paper-plane-o': '\uF1D9',
        'fa-history': '\uF1DA',
        'fa-circle-thin': '\uF1DB',
        'fa-header': '\uF1DC',
        'fa-paragraph': '\uF1DD',
        'fa-sliders': '\uF1DE',
        'fa-share-alt': '\uF1E0',
        'fa-share-alt-square': '\uF1E1',
        'fa-bomb': '\uF1E2',
        'fa-soccer-ball-o': '\uF1E3',
        'fa-futbol-o': '\uF1E3',
        'fa-tty': '\uF1E4',
        'fa-binoculars': '\uF1E5',
        'fa-plug': '\uF1E6',
        'fa-slideshare': '\uF1E7',
        'fa-twitch': '\uF1E8',
        'fa-yelp': '\uF1E9',
        'fa-newspaper-o': '\uF1EA',
        'fa-wifi': '\uF1EB',
        'fa-calculator': '\uF1EC',
        'fa-paypal': '\uF1ED',
        'fa-google-wallet': '\uF1EE',
        'fa-cc-visa': '\uF1F0',
        'fa-cc-mastercard': '\uF1F1',
        'fa-cc-discover': '\uF1F2',
        'fa-cc-amex': '\uF1F3',
        'fa-cc-paypal': '\uF1F4',
        'fa-cc-stripe': '\uF1F5',
        'fa-bell-slash': '\uF1F6',
        'fa-bell-slash-o': '\uF1F7',
        'fa-trash': '\uF1F8',
        'fa-copyright': '\uF1F9',
        'fa-at': '\uF1FA',
        'fa-eyedropper': '\uF1FB',
        'fa-paint-brush': '\uF1FC',
        'fa-birthday-cake': '\uF1FD',
        'fa-area-t': '\uF1FE',
        'fa-pie-t': '\uF200',
        'fa-line-t': '\uF201',
        'fa-lastfm': '\uF202',
        'fa-lastfm-square': '\uF203',
        'fa-toggle-off': '\uF204',
        'fa-toggle-on': '\uF205',
        'fa-bicycle': '\uF206',
        'fa-bus': '\uF207',
        'fa-ioxhost': '\uF208',
        'fa-angellist': '\uF209',
        'fa-cc': '\uF20A',
        'fa-shekel': '\uF20B',
        'fa-sheqel': '\uF20B',
        'fa-ils': '\uF20B',
        'fa-meanpath': '\uF20C',
        'fa-buysellads': '\uF20D',
        'fa-connectdevelop': '\uF20E',
        'fa-dashcube': '\uF210',
        'fa-forumbee': '\uF211',
        'fa-leanpub': '\uF212',
        'fa-sellsy': '\uF213',
        'fa-shirtsinbulk': '\uF214',
        'fa-simplybuilt': '\uF215',
        'fa-skyatlas': '\uF216',
        'fa-cart-plus': '\uF217',
        'fa-cart-arrow-down': '\uF218',
        'fa-diamond': '\uF219',
        'fa-ship': '\uF21A',
        'fa-user-secret': '\uF21B',
        'fa-motorcycle': '\uF21C',
        'fa-street-view': '\uF21D',
        'fa-heartbeat': '\uF21E',
        'fa-venus': '\uF221',
        'fa-mars': '\uF222',
        'fa-mercury': '\uF223',
        'fa-intersex': '\uF224',
        'fa-transgender': '\uF224',
        'fa-transgender-alt': '\uF225',
        'fa-venus-double': '\uF226',
        'fa-mars-double': '\uF227',
        'fa-venus-mars': '\uF228',
        'fa-mars-stroke': '\uF229',
        'fa-mars-stroke-v': '\uF22A',
        'fa-mars-stroke-h': '\uF22B',
        'fa-neuter': '\uF22C',
        'fa-genderless': '\uF22D',
        'fa-facebook-official': '\uF230',
        'fa-pinterest-p': '\uF231',
        'fa-whatsapp': '\uF232',
        'fa-server': '\uF233',
        'fa-user-plus': '\uF234',
        'fa-user-times': '\uF235',
        'fa-hotel': '\uF236',
        'fa-bed': '\uF236',
        'fa-viacoin': '\uF237',
        'fa-train': '\uF238',
        'fa-subway': '\uF239',
        'fa-medium': '\uF23A',
        'fa-yc': '\uF23B',
        'fa-y-combinator': '\uF23B',
        'fa-optin-monster': '\uF23C',
        'fa-opencart': '\uF23D',
        'fa-expeditedssl': '\uF23E',
        'fa-battery-4': '\uF240',
        'fa-battery-full': '\uF240',
        'fa-battery-3': '\uF241',
        'fa-battery-three-quarters': '\uF241',
        'fa-battery-2': '\uF242',
        'fa-battery-half': '\uF242',
        'fa-battery-1': '\uF243',
        'fa-battery-quarter': '\uF243',
        'fa-battery-0': '\uF244',
        'fa-battery-empty': '\uF244',
        'fa-mouse-pointer': '\uF245',
        'fa-i-cursor': '\uF246',
        'fa-object-group': '\uF247',
        'fa-object-ungroup': '\uF248',
        'fa-sticky-note': '\uF249',
        'fa-sticky-note-o': '\uF24A',
        'fa-cc-jcb': '\uF24B',
        'fa-cc-diners-club': '\uF24C',
        'fa-clone': '\uF24D',
        'fa-balance-scale': '\uF24E',
        'fa-hourglass-o': '\uF250',
        'fa-hourglass-1': '\uF251',
        'fa-hourglass-start': '\uF251',
        'fa-hourglass-2': '\uF252',
        'fa-hourglass-half': '\uF252',
        'fa-hourglass-3': '\uF253',
        'fa-hourglass-end': '\uF253',
        'fa-hourglass': '\uF254',
        'fa-hand-grab-o': '\uF255',
        'fa-hand-rock-o': '\uF255',
        'fa-hand-stop-o': '\uF256',
        'fa-hand-paper-o': '\uF256',
        'fa-hand-scissors-o': '\uF257',
        'fa-hand-lizard-o': '\uF258',
        'fa-hand-spock-o': '\uF259',
        'fa-hand-pointer-o': '\uF25A',
        'fa-hand-peace-o': '\uF25B',
        'fa-trademark': '\uF25C',
        'fa-registered': '\uF25D',
        'fa-creative-commons': '\uF25E',
        'fa-gg': '\uF260',
        'fa-gg-circle': '\uF261',
        'fa-tripadvisor': '\uF262',
        'fa-odnoklassniki': '\uF263',
        'fa-odnoklassniki-square': '\uF264',
        'fa-get-pocket': '\uF265',
        'fa-wikipedia-w': '\uF266',
        'fa-safari': '\uF267',
        'fa-chrome': '\uF268',
        'fa-firefox': '\uF269',
        'fa-opera': '\uF26A',
        'fa-internet-explorer': '\uF26B',
        'fa-tv': '\uF26C',
        'fa-television': '\uF26C',
        'fa-contao': '\uF26D',
        'fa-500px': '\uF26E',
        'fa-amazon': '\uF270',
        'fa-calendar-plus-o': '\uF271',
        'fa-calendar-minus-o': '\uF272',
        'fa-calendar-times-o': '\uF273',
        'fa-calendar-check-o': '\uF274',
        'fa-industry': '\uF275',
        'fa-map-pin': '\uF276',
        'fa-map-signs': '\uF277',
        'fa-map-o': '\uF278',
        'fa-map': '\uF279',
        'fa-commenting': '\uF27A',
        'fa-commenting-o': '\uF27B',
        'fa-houzz': '\uF27C',
        'fa-vimeo': '\uF27D',
        'fa-black-tie': '\uF27E',
        'fa-fonticons': '\uF280',
    })
}

/* Copyright (c) 2014 by Jean-Marc.Viglino [at]ign.fr
* Dual-licensed under the CeCILL-B Licence (http://www.cecill.info/)
* and the Beerware license (http://en.wikipedia.org/wiki/Beerware),
*
* Font definiton to use with fontsymbols
*/
function loadMakiDefs(): void {
    FontSymbol.addDefs({
        font: 'fontmaki',
        name: 'Maki',
        copyright: 'CC0 - MapBox - https://www.mapbox.com/maki/',
        prefix: 'maki',
    }, {
        'maki-bicycle': { font: 'fontmaki', code: 59392, name: 'bicycle', search: 'bicycle' },
        'maki-building': { font: 'fontmaki', code: 59393, name: 'building', search: 'building' },
        'maki-bus': { font: 'fontmaki', code: 59394, name: 'bus', search: 'bus' },
        'maki-cafe': { font: 'fontmaki', code: 59395, name: 'cafe', search: 'cafe' },
        'maki-camera': { font: 'fontmaki', code: 59396, name: 'camera', search: 'camera' },
        'maki-campsite': { font: 'fontmaki', code: 59397, name: 'campsite', search: 'campsite' },
        'maki-car': { font: 'fontmaki', code: 59398, name: 'car', search: 'car' },
        'maki-cemetery': { font: 'fontmaki', code: 59399, name: 'cemetery', search: 'cemetery' },
        'maki-chemist': { font: 'fontmaki', code: 59400, name: 'chemist', search: 'chemist' },
        'maki-cinema': { font: 'fontmaki', code: 59401, name: 'cinema', search: 'cinema' },
        'maki-circle': { font: 'fontmaki', code: 59402, name: 'circle', search: 'circle' },
        'maki-circle_stroked': { font: 'fontmaki', code: 59403, name: 'circle_stroked', search: 'circle_stroked' },
        'maki-city': { font: 'fontmaki', code: 59404, name: 'city', search: 'city' },
        'maki-clothing_store': { font: 'fontmaki', code: 59405, name: 'clothing_store', search: 'clothing_store' },
        'maki-college': { font: 'fontmaki', code: 59406, name: 'college', search: 'college' },
        'maki-commercial': { font: 'fontmaki', code: 59407, name: 'commercial', search: 'commercial' },
        'maki-cricket': { font: 'fontmaki', code: 59408, name: 'cricket', search: 'cricket' },
        'maki-cross': { font: 'fontmaki', code: 59409, name: 'cross', search: 'cross' },
        'maki-dam': { font: 'fontmaki', code: 59410, name: 'dam', search: 'dam' },
        'maki-danger': { font: 'fontmaki', code: 59411, name: 'danger', search: 'danger' },
        'maki-dentist': { font: 'fontmaki', code: 59412, name: 'dentist', search: 'dentist' },
        'maki-disability': { font: 'fontmaki', code: 59413, name: 'disability', search: 'disability' },
        'maki-dog_park': { font: 'fontmaki', code: 59414, name: 'dog_park', search: 'dog_park' },
        'maki-embassy': { font: 'fontmaki', code: 59415, name: 'embassy', search: 'embassy' },
        'maki-emergency_telephone': {
            font: 'fontmaki',
            code: 59416,
            name: 'emergency_telephone',
            search: 'emergency_telephone',
        },
        'maki-entrance': { font: 'fontmaki', code: 59417, name: 'entrance', search: 'entrance' },
        'maki-farm': { font: 'fontmaki', code: 59418, name: 'farm', search: 'farm' },
        'maki-fast_food': { font: 'fontmaki', code: 59419, name: 'fast_food', search: 'fast_food' },
        'maki-ferry': { font: 'fontmaki', code: 59420, name: 'ferry', search: 'ferry' },
        'maki-fire_station': { font: 'fontmaki', code: 59421, name: 'fire_station', search: 'fire_station' },
        'maki-fuel': { font: 'fontmaki', code: 59422, name: 'fuel', search: 'fuel' },
        'maki-garden': { font: 'fontmaki', code: 59423, name: 'garden', search: 'garden' },
        'maki-gift': { font: 'fontmaki', code: 59424, name: 'gift', search: 'gift' },
        'maki-golf': { font: 'fontmaki', code: 59425, name: 'golf', search: 'golf' },
        'maki-grocery': { font: 'fontmaki', code: 59426, name: 'grocery', search: 'grocery' },
        'maki-hairdresser': { font: 'fontmaki', code: 59427, name: 'hairdresser', search: 'hairdresser' },
        'maki-harbor': { font: 'fontmaki', code: 59428, name: 'harbor', search: 'harbor' },
        'maki-heart': { font: 'fontmaki', code: 59429, name: 'heart', search: 'heart' },
        'maki-heliport': { font: 'fontmaki', code: 59430, name: 'heliport', search: 'heliport' },
        'maki-hospital': { font: 'fontmaki', code: 59431, name: 'hospital', search: 'hospital' },
        'maki-ice_cream': { font: 'fontmaki', code: 59432, name: 'ice_cream', search: 'ice_cream' },
        'maki-industrial': { font: 'fontmaki', code: 59433, name: 'industrial', search: 'industrial' },
        'maki-land_use': { font: 'fontmaki', code: 59434, name: 'land_use', search: 'land_use' },
        'maki-laundry': { font: 'fontmaki', code: 59435, name: 'laundry', search: 'laundry' },
        'maki-library': { font: 'fontmaki', code: 59436, name: 'library', search: 'library' },
        'maki-lighthouse': { font: 'fontmaki', code: 59437, name: 'lighthouse', search: 'lighthouse' },
        'maki-lodging': { font: 'fontmaki', code: 59438, name: 'lodging', search: 'lodging' },
        'maki-logging': { font: 'fontmaki', code: 59439, name: 'logging', search: 'logging' },
        'maki-london_underground': {
            font: 'fontmaki',
            code: 59440,
            name: 'london_underground',
            search: 'london_underground',
        },
        'maki-marker': { font: 'fontmaki', code: 59441, name: 'marker', search: 'marker' },
        'maki-minefield': { font: 'fontmaki', code: 59442, name: 'minefield', search: 'minefield' },
        'maki-marker_stroked': { font: 'fontmaki', code: 59443, name: 'marker_stroked', search: 'marker_stroked' },
        'maki-mobilephone': { font: 'fontmaki', code: 59444, name: 'mobilephone', search: 'mobilephone' },
        'maki-monument': { font: 'fontmaki', code: 59445, name: 'monument', search: 'monument' },
        'maki-museum': { font: 'fontmaki', code: 59446, name: 'museum', search: 'museum' },
        'maki-music': { font: 'fontmaki', code: 59447, name: 'music', search: 'music' },
        'maki-oil_well': { font: 'fontmaki', code: 59448, name: 'oil_well', search: 'oil_well' },
        'maki-park': { font: 'fontmaki', code: 59449, name: 'park', search: 'park' },
        'maki-park2': { font: 'fontmaki', code: 59450, name: 'park2', search: 'park2' },
        'maki-parking': { font: 'fontmaki', code: 59451, name: 'parking', search: 'parking' },
        'maki-parking_garage': { font: 'fontmaki', code: 59452, name: 'parking_garage', search: 'parking_garage' },
        'maki-pharmacy': { font: 'fontmaki', code: 59453, name: 'pharmacy', search: 'pharmacy' },
        'maki-pitch': { font: 'fontmaki', code: 59454, name: 'pitch', search: 'pitch' },
        'maki-playground': { font: 'fontmaki', code: 59455, name: 'playground', search: 'playground' },
        'maki-police': { font: 'fontmaki', code: 59456, name: 'police', search: 'police' },
        'maki-polling_place': { font: 'fontmaki', code: 59457, name: 'polling_place', search: 'polling_place' },
        'maki-post': { font: 'fontmaki', code: 59458, name: 'post', search: 'post' },
        'maki-prison': { font: 'fontmaki', code: 59459, name: 'prison', search: 'prison' },
        'maki-rail': { font: 'fontmaki', code: 59460, name: 'rail', search: 'rail' },
        'maki-rail_above': { font: 'fontmaki', code: 59461, name: 'rail_above', search: 'rail_above' },
        'maki-rail_light': { font: 'fontmaki', code: 59462, name: 'rail_light', search: 'rail_light' },
        'maki-rail_metro': { font: 'fontmaki', code: 59463, name: 'rail_metro', search: 'rail_metro' },
        'maki-rail_underground': {
            font: 'fontmaki',
            code: 59464,
            name: 'rail_underground',
            search: 'rail_underground',
        },
        'maki-religious-christian': {
            font: 'fontmaki',
            code: 59465,
            theme: 'religious',
            name: 'christian',
            search: 'religious,christian',
        },
        'maki-religious-jewish': {
            font: 'fontmaki',
            code: 59466,
            theme: 'religious',
            name: 'jewish',
            search: 'religious,jewish',
        },
        'maki-religious-muslim': {
            font: 'fontmaki',
            code: 59467,
            theme: 'religious',
            name: 'muslim',
            search: 'religious,muslim',
        },
        'maki-religious-place_of_worship': {
            font: 'fontmaki',
            code: 59468,
            theme: 'religious',
            name: 'place_of_worship',
            search: 'religious,place_of_worship',
        },
        'maki-restaurant': { font: 'fontmaki', code: 59469, name: 'restaurant', search: 'restaurant' },
        'maki-roadblock': { font: 'fontmaki', code: 59470, name: 'roadblock', search: 'roadblock' },
        'maki-rocket': { font: 'fontmaki', code: 59471, name: 'rocket', search: 'rocket' },
        'maki-school': { font: 'fontmaki', code: 59472, name: 'school', search: 'school' },
        'maki-scooter': { font: 'fontmaki', code: 59473, name: 'scooter', search: 'scooter' },
        'maki-shop': { font: 'fontmaki', code: 59474, name: 'shop', search: 'shop' },
        'maki-skiing': { font: 'fontmaki', code: 59475, name: 'skiing', search: 'skiing' },
        'maki-slaughterhouse': { font: 'fontmaki', code: 59476, name: 'slaughterhouse', search: 'slaughterhouse' },
        'maki-soccer': { font: 'fontmaki', code: 59477, name: 'soccer', search: 'soccer' },
        'maki-square': { font: 'fontmaki', code: 59478, name: 'square', search: 'square' },
        'maki-square_stroked': { font: 'fontmaki', code: 59479, name: 'square_stroked', search: 'square_stroked' },
        'maki-star': { font: 'fontmaki', code: 59480, name: 'star', search: 'star' },
        'maki-star_stroked': { font: 'fontmaki', code: 59481, name: 'star_stroked', search: 'star_stroked' },
        'maki-suitcase': { font: 'fontmaki', code: 59482, name: 'suitcase', search: 'suitcase' },
        'maki-swimming': { font: 'fontmaki', code: 59483, name: 'swimming', search: 'swimming' },
        'maki-telephone': { font: 'fontmaki', code: 59484, name: 'telephone', search: 'telephone' },
        'maki-tennis': { font: 'fontmaki', code: 59485, name: 'tennis', search: 'tennis' },
        'maki-theatre': { font: 'fontmaki', code: 59486, name: 'theatre', search: 'theatre' },
        'maki-toilets': { font: 'fontmaki', code: 59487, name: 'toilets', search: 'toilets' },
        'maki-town': { font: 'fontmaki', code: 59488, name: 'town', search: 'town' },
        'maki-town_hall': { font: 'fontmaki', code: 59489, name: 'town_hall', search: 'town_hall' },
        'maki-triangle': { font: 'fontmaki', code: 59490, name: 'triangle', search: 'triangle' },
        'maki-triangle_stroked': {
            font: 'fontmaki',
            code: 59491,
            name: 'triangle_stroked',
            search: 'triangle_stroked',
        },
        'maki-village': { font: 'fontmaki', code: 59492, name: 'village', search: 'village' },
        'maki-warehouse': { font: 'fontmaki', code: 59493, name: 'warehouse', search: 'warehouse' },
        'maki-waste_basket': { font: 'fontmaki', code: 59494, name: 'waste_basket', search: 'waste_basket' },
        'maki-water': { font: 'fontmaki', code: 59495, name: 'water', search: 'water' },
        'maki-wetland': { font: 'fontmaki', code: 59496, name: 'wetland', search: 'wetland' },
        'maki-zoo': { font: 'fontmaki', code: 59497, name: 'zoo', search: 'zoo' },
        'maki-aerialway': { font: 'fontmaki', code: 59498, name: 'aerialway', search: 'aerialway' },
        'maki-airfield': { font: 'fontmaki', code: 59499, name: 'airfield', search: 'airfield' },
        'maki-airport': { font: 'fontmaki', code: 59500, name: 'airport', search: 'airport' },
        'maki-alcohol_shop': { font: 'fontmaki', code: 59501, name: 'alcohol_shop', search: 'alcohol_shop' },
        'maki-america_football': {
            font: 'fontmaki',
            code: 59502,
            name: 'america_football',
            search: 'america_football',
        },
        'maki-art_gallery': { font: 'fontmaki', code: 59503, name: 'art_gallery', search: 'art_gallery' },
        'maki-bakery': { font: 'fontmaki', code: 59504, name: 'bakery', search: 'bakery' },
        'maki-bank': { font: 'fontmaki', code: 59505, name: 'bank', search: 'bank' },
        'maki-bar': { font: 'fontmaki', code: 59506, name: 'bar', search: 'bar' },
        'maki-baseball': { font: 'fontmaki', code: 59507, name: 'baseball', search: 'baseball' },
        'maki-basketball': { font: 'fontmaki', code: 59508, name: 'basketball', search: 'basketball' },
        'maki-beer': { font: 'fontmaki', code: 59509, name: 'beer', search: 'beer' },
    })
}

/* Copyright CC0 - MapBox - https://www.mapbox.com/maki/ - fontmaki2
*
* Font definiton to use with fontsymbols
*/
function loadMaki2Defs(): void {
    FontSymbol.addDefs({
        font: 'fontmaki2',
        name: 'Maki2',
        copyright: 'CC0 - MapBox - https://www.mapbox.com/maki/',
        prefix: 'maki2',
    }, {
        'maki2-aerialway': {
            font: 'fontmaki2',
            code: 59392,
            name: 'aerialway',
            search: 'telepherique,ski,neige',
            theme: 'transport',
        },
        'maki2-airfield': {
            font: 'fontmaki2',
            code: 59393,
            name: 'airfield',
            search: 'aerodrome,avion',
            theme: 'transport',
        },
        'maki2-airport': {
            font: 'fontmaki2',
            code: 59394,
            name: 'airport',
            search: 'aeroport,avion',
            theme: 'transport',
        },
        'maki2-alcohol-shop': {
            font: 'fontmaki2',
            code: 59395,
            theme: 'commerce',
            name: 'shop',
            search: 'boisson,alcool,vin,verre',
        },
        'maki2-america-football': {
            font: 'fontmaki2',
            code: 59396,
            theme: 'sport',
            name: 'football',
            search: 'fooball,rugby',
        },
        'maki2-amusement-park': {
            font: 'fontmaki2',
            code: 59397,
            theme: 'loisir',
            name: 'park',
            search: 'pac,roue,attraction',
        },
        'maki2-aquarium': {
            font: 'fontmaki2',
            code: 59398,
            name: 'aquarium',
            search: 'aquarium,poison,mer,animal',
            theme: 'loisir',
        },
        'maki2-art-gallery': {
            font: 'fontmaki2',
            code: 59399,
            theme: 'loisir',
            name: 'gallery',
            search: 'art,gallerie,peinture',
        },
        'maki2-attraction': {
            font: 'fontmaki2',
            code: 59400,
            name: 'attraction',
            search: 'photo,attraction,camera',
            theme: 'tourisme',
        },
        'maki2-bakery': {
            font: 'fontmaki2',
            code: 59401,
            name: 'bakery',
            search: 'boulangerie,croissant',
            theme: 'commerce',
        },
        'maki2-bank': {
            font: 'fontmaki2',
            code: 59402,
            name: 'bank',
            search: 'banque,carte,paiment',
            theme: 'service',
        },
        'maki2-bar': {
            font: 'fontmaki2',
            code: 59403,
            name: 'bar',
            search: 'bar,coupe,verre,boisson',
            theme: 'commerce',
        },
        'maki2-barrier': {
            font: 'fontmaki2',
            code: 59404,
            name: 'barrier',
            search: 'barriere,travaux',
            theme: 'service',
        },
        'maki2-baseball': { font: 'fontmaki2', code: 59405, name: 'baseball', search: 'baseball', theme: 'sport' },
        'maki2-basketball': {
            font: 'fontmaki2',
            code: 59406,
            name: 'basketball',
            search: 'basketball,ballon',
            theme: 'sport',
        },
        'maki2-bbq': { font: 'fontmaki2', code: 59407, name: 'bbq', search: 'bbq,barbecue,camping', theme: 'loisir' },
        'maki2-beer': { font: 'fontmaki2', code: 59408, name: 'beer', search: 'biere,boisson,cafe', theme: 'commerce' },
        'maki2-bicycle': {
            font: 'fontmaki2',
            code: 59409,
            name: 'bicycle',
            search: 'velo,cycle,bicyclette',
            theme: 'transport',
        },
        'maki2-bicycle-share': {
            font: 'fontmaki2',
            code: 59410,
            theme: 'transport',
            name: 'share',
            search: 'velo,cycle,bicyclette',
        },
        'maki2-blood-bank': {
            font: 'fontmaki2',
            code: 59411,
            theme: 'service',
            name: 'bank',
            search: 'santé,sang,don',
        },
        'maki2-buddhism': { font: 'fontmaki2', code: 59412, name: 'buddhism', search: 'bouddhisme', theme: 'religion' },
        'maki2-building': {
            font: 'fontmaki2',
            code: 59413,
            name: 'building',
            search: 'maison,batiment',
            theme: 'construction',
        },
        'maki2-building-alt1': {
            font: 'fontmaki2',
            code: 59414,
            theme: 'construction',
            name: 'alt1',
            search: 'building,tour,immeuble',
        },
        'maki2-bus': { font: 'fontmaki2', code: 59415, name: 'bus', search: 'bus', theme: 'transport' },
        'maki2-cafe': { font: 'fontmaki2', code: 59416, name: 'cafe', search: 'cafe,bar', theme: 'commerce' },
        'maki2-campsite': {
            font: 'fontmaki2',
            code: 59417,
            name: 'campsite',
            search: 'camping,tente',
            theme: 'tourisme',
        },
        'maki2-car': { font: 'fontmaki2', code: 59418, name: 'car', search: 'voiture', theme: 'transport' },
        'maki2-car-rental': {
            font: 'fontmaki2',
            code: 59419,
            theme: 'service',
            name: 'rental',
            search: 'voiture,location,parking',
        },
        'maki2-car-repair': {
            font: 'fontmaki2',
            code: 59420,
            theme: 'service',
            name: 'repair',
            search: 'voiture,reparation,mecanique',
        },
        'maki2-casino': {
            font: 'fontmaki2',
            code: 59421,
            name: 'casino',
            search: 'casino,carte,pique',
            theme: 'loisir',
        },
        'maki2-castle': { font: 'fontmaki2', code: 59422, name: 'castle', search: 'chateau,tour', theme: 'loisir' },
        'maki2-cemetery': {
            font: 'fontmaki2',
            code: 59423,
            name: 'cemetery',
            search: 'cimetiere,tombe',
            theme: 'religion',
        },
        'maki2-charging-station': {
            font: 'fontmaki2',
            code: 59424,
            theme: 'transport',
            name: 'station',
            search: 'voiture,chargement,electrique,station',
        },
        'maki2-cinema': { font: 'fontmaki2', code: 59425, name: 'cinema', search: 'cinema,film', theme: 'tourisme' },
        'maki2-circle': { font: 'fontmaki2', code: 59426, name: 'circle', search: 'cercle', theme: 'forme' },
        'maki2-circle-stroked': {
            font: 'fontmaki2',
            code: 59427,
            theme: 'forme',
            name: 'stroked',
            search: 'cercle,rond',
        },
        'maki2-city': {
            font: 'fontmaki2',
            code: 59428,
            name: 'city',
            search: 'ville,batiment,hlm',
            theme: 'construction',
        },
        'maki2-clothing-store': {
            font: 'fontmaki2',
            code: 59429,
            theme: 'commerce',
            name: 'store',
            search: 'vetement,magasin',
        },
        'maki2-college': {
            font: 'fontmaki2',
            code: 59430,
            name: 'college',
            search: 'college,universite',
            theme: 'education',
        },
        'maki2-commercial': {
            font: 'fontmaki2',
            code: 59431,
            name: 'commercial',
            search: 'commercial,tour',
            theme: 'construction',
        },
        'maki2-cricket': { font: 'fontmaki2', code: 59432, name: 'cricket', search: 'cricket', theme: 'sport' },
        'maki2-cross': { font: 'fontmaki2', code: 59433, name: 'cross', search: 'croix', theme: 'forme' },
        'maki2-dam': { font: 'fontmaki2', code: 59434, name: 'dam', search: 'barrage,eau', theme: 'industrie' },
        'maki2-danger': {
            font: 'fontmaki2',
            code: 59435,
            name: 'danger',
            search: 'danger,mort,tete',
            theme: 'panneau',
        },
        'maki2-defibrillator': {
            font: 'fontmaki2',
            code: 59436,
            name: 'defibrillator',
            search: 'defibrillateur,medecin,sante',
            theme: 'service',
        },
        'maki2-dentist': {
            font: 'fontmaki2',
            code: 59437,
            name: 'dentist',
            search: 'dentiste,sante',
            theme: 'service',
        },
        'maki2-doctor': {
            font: 'fontmaki2',
            code: 59438,
            name: 'doctor',
            search: 'docteur,medecin,stetoscope',
            theme: 'service',
        },
        'maki2-dog-park': { font: 'fontmaki2', code: 59439, theme: 'service', name: 'park', search: 'chien,parc' },
        'maki2-drinking-water': {
            font: 'fontmaki2',
            code: 59440,
            theme: 'service',
            name: 'water',
            search: 'eau,ba,boison,robinet',
        },
        'maki2-embassy': { font: 'fontmaki2', code: 59441, name: 'embassy', search: 'ambassade', theme: 'service' },
        'maki2-emergency-phone': {
            font: 'fontmaki2',
            code: 59442,
            theme: 'service',
            name: 'phone',
            search: 'urgence,sante,telephone',
        },
        'maki2-entrance': { font: 'fontmaki2', code: 59443, name: 'entrance', search: 'entree', theme: 'construction' },
        'maki2-entrance-alt1': {
            font: 'fontmaki2',
            code: 59444,
            theme: 'service',
            name: 'alt1',
            search: 'sortie,secours',
        },
        'maki2-farm': { font: 'fontmaki2', code: 59445, name: 'farm', search: 'ferme,batiment', theme: 'construction' },
        'maki2-fast-food': {
            font: 'fontmaki2',
            code: 59446,
            theme: 'commerce',
            name: 'food',
            search: 'fast food,retaurant,hamburger',
        },
        'maki2-fence': { font: 'fontmaki2', code: 59447, name: 'fence', search: 'herse,barriere', theme: 'panneau' },
        'maki2-ferry': {
            font: 'fontmaki2',
            code: 59448,
            name: 'ferry',
            search: 'ferry,bac,bateau',
            theme: 'transport',
        },
        'maki2-fire-station': {
            font: 'fontmaki2',
            code: 59449,
            theme: 'service',
            name: 'station',
            search: 'pompier,feu,station',
        },
        'maki2-florist': {
            font: 'fontmaki2',
            code: 59450,
            name: 'florist',
            search: 'fleur,fleuriste,nature',
            theme: 'commerce',
        },
        'maki2-fuel': { font: 'fontmaki2', code: 59451, name: 'fuel', search: 'pompe,essence', theme: 'commerce' },
        'maki2-furniture': {
            font: 'fontmaki2',
            code: 59452,
            name: 'furniture',
            search: 'meuble,lampe,magazin',
            theme: 'commerce',
        },
        'maki2-gaming': {
            font: 'fontmaki2',
            code: 59453,
            name: 'gaming',
            search: 'gaming,jeu,manette,console',
            theme: 'commerce',
        },
        'maki2-garden': { font: 'fontmaki2', code: 59454, name: 'garden', search: 'jardin,fleur', theme: 'loisir' },
        'maki2-garden-center': {
            font: 'fontmaki2',
            code: 59455,
            theme: 'loisir',
            name: 'center',
            search: 'jardin,arrosoir,fleur',
        },
        'maki2-gift': { font: 'fontmaki2', code: 59456, name: 'gift', search: 'cadeau,achat', theme: 'commerce' },
        'maki2-globe': { font: 'fontmaki2', code: 59457, name: 'globe', search: 'globe,terre', theme: 'divers' },
        'maki2-golf': { font: 'fontmaki2', code: 59458, name: 'golf', search: 'golf', theme: 'sport' },
        'maki2-grocery': {
            font: 'fontmaki2',
            code: 59459,
            name: 'grocery',
            search: 'caddy,super,marche',
            theme: 'commerce',
        },
        'maki2-hairdresser': {
            font: 'fontmaki2',
            code: 59460,
            name: 'hairdresser',
            search: 'coiffeur',
            theme: 'commerce',
        },
        'maki2-harbor': {
            font: 'fontmaki2',
            code: 59461,
            name: 'harbor',
            search: 'port,bateau,ancre',
            theme: 'transport',
        },
        'maki2-hardware': {
            font: 'fontmaki2',
            code: 59462,
            name: 'hardware',
            search: 'mecanicien,outil',
            theme: 'service',
        },
        'maki2-heart': { font: 'fontmaki2', code: 59463, name: 'heart', search: 'coeur,amour', theme: 'forme' },
        'maki2-heliport': {
            font: 'fontmaki2',
            code: 59464,
            name: 'heliport',
            search: 'heliport,helicoptere',
            theme: 'transport',
        },
        'maki2-home': { font: 'fontmaki2', code: 59465, name: 'home', search: 'maison,bati', theme: 'construction' },
        'maki2-horse-riding': {
            font: 'fontmaki2',
            code: 59466,
            theme: 'sport',
            name: 'riding',
            search: 'animal,cavalier,cheval',
        },
        'maki2-hospital': {
            font: 'fontmaki2',
            code: 59467,
            name: 'hospital',
            search: 'hopital,croix',
            theme: 'service',
        },
        'maki2-ice-cream': {
            font: 'fontmaki2',
            code: 59468,
            theme: 'loisir',
            name: 'cream',
            search: 'glace,cornet,enfant',
        },
        'maki2-industry': {
            font: 'fontmaki2',
            code: 59469,
            name: 'industry',
            search: 'industrie,usine,cheminee',
            theme: 'industrie',
        },
        'maki2-information': {
            font: 'fontmaki2',
            code: 59470,
            name: 'information',
            search: 'information,i',
            theme: 'tourisme',
        },
        'maki2-jewelry': {
            font: 'fontmaki2',
            code: 59471,
            name: 'jewelry',
            search: 'bijoutier,bague,or',
            theme: 'commerce',
        },
        'maki2-karaoke': {
            font: 'fontmaki2',
            code: 59472,
            name: 'karaoke',
            search: 'karaoke,micro,chant',
            theme: 'commerce',
        },
        'maki2-landmark': { font: 'fontmaki2', code: 59473, name: 'landmark', search: 'manege,info', theme: 'service' },
        'maki2-landuse': {
            font: 'fontmaki2',
            code: 59474,
            name: 'landuse',
            search: 'paysage,maison',
            theme: 'paysage',
        },
        'maki2-laundry': {
            font: 'fontmaki2',
            code: 59475,
            name: 'laundry',
            search: 'machine,laver,blanchisserie',
            theme: 'commerce',
        },
        'maki2-library': {
            font: 'fontmaki2',
            code: 59476,
            name: 'library',
            search: 'livre,bibliotheque',
            theme: 'service',
        },
        'maki2-lighthouse': {
            font: 'fontmaki2',
            code: 59477,
            name: 'lighthouse',
            search: 'phare,lumiere',
            theme: 'transport',
        },
        'maki2-lodging': { font: 'fontmaki2', code: 59478, name: 'lodging', search: 'lit,hotel', theme: 'hebergement' },
        'maki2-logging': {
            font: 'fontmaki2',
            code: 59479,
            name: 'logging',
            search: 'enregistrement',
            theme: 'hebergement',
        },
        'maki2-marker': { font: 'fontmaki2', code: 59480, name: 'marker', search: 'marker,poi', theme: 'forme' },
        'maki2-marker-stroked': {
            font: 'fontmaki2',
            code: 59481,
            theme: 'forme',
            name: 'stroked',
            search: 'marker,poi',
        },
        'maki2-mobile-phone': {
            font: 'fontmaki2',
            code: 59482,
            theme: 'divers',
            name: 'phone',
            search: 'mobile,telephone',
        },
        'maki2-monument': {
            font: 'fontmaki2',
            code: 59483,
            name: 'monument',
            search: 'monument,obelix,tour',
            theme: 'construction',
        },
        'maki2-mountain': {
            font: 'fontmaki2',
            code: 59484,
            name: 'mountain',
            search: 'montagne,mont,neige',
            theme: 'paysage',
        },
        'maki2-museum': { font: 'fontmaki2', code: 59485, name: 'museum', search: 'musee,maison', theme: 'tourisme' },
        'maki2-music': { font: 'fontmaki2', code: 59486, name: 'music', search: 'musique,note', theme: 'loisir' },
        'maki2-natural': { font: 'fontmaki2', code: 59487, name: 'natural', search: 'naturel,arbre', theme: 'paysage' },
        'maki2-optician': {
            font: 'fontmaki2',
            code: 59488,
            name: 'optician',
            search: 'lunette,opticien',
            theme: 'commerce',
        },
        'maki2-paint': {
            font: 'fontmaki2',
            code: 59489,
            name: 'paint',
            search: 'peintre,peinture,rouleau',
            theme: 'commerce',
        },
        'maki2-park': { font: 'fontmaki2', code: 59490, name: 'park', search: 'parc,arbre,feuille', theme: 'paysage' },
        'maki2-park-alt1': {
            font: 'fontmaki2',
            code: 59491,
            theme: 'paysage',
            name: 'alt1',
            search: 'parc,arbre,sapin',
        },
        'maki2-parking': { font: 'fontmaki2', code: 59492, name: 'parking', search: 'parking,p', theme: 'transport' },
        'maki2-parking-garage': {
            font: 'fontmaki2',
            code: 59493,
            theme: 'transport',
            name: 'garage',
            search: 'parking,garage',
        },
        'maki2-pharmacy': {
            font: 'fontmaki2',
            code: 59494,
            name: 'pharmacy',
            search: 'pharmacie,medicament',
            theme: 'service',
        },
        'maki2-picnic-site': {
            font: 'fontmaki2',
            code: 59495,
            theme: 'loisir',
            name: 'site',
            search: 'picnic,site,halte,aire',
        },
        'maki2-pitch': { font: 'fontmaki2', code: 59496, name: 'pitch', search: 'saut,course', theme: 'sport' },
        'maki2-place-of-worship': {
            font: 'fontmaki2',
            code: 59497,
            theme: 'construction',
            name: 'of',
            search: 'place,immeuble,chateau',
        },
        'maki2-playground': {
            font: 'fontmaki2',
            code: 59498,
            name: 'playground',
            search: 'balancoire,enfant,jardin',
            theme: 'loisir',
        },
        'maki2-police': { font: 'fontmaki2', code: 59499, name: 'police', search: 'police,kepi', theme: 'service' },
        'maki2-post': { font: 'fontmaki2', code: 59500, name: 'post', search: 'poste,lettre', theme: 'service' },
        'maki2-prison': {
            font: 'fontmaki2',
            code: 59501,
            name: 'prison',
            search: 'prison,herse,barriere',
            theme: 'service',
        },
        'maki2-rail': { font: 'fontmaki2', code: 59502, name: 'rail', search: 'rail,fer', theme: 'transport' },
        'maki2-rail-light': {
            font: 'fontmaki2',
            code: 59503,
            theme: 'transport',
            name: 'light',
            search: 'transport,train,sncf,rail',
        },
        'maki2-rail-metro': {
            font: 'fontmaki2',
            code: 59504,
            theme: 'transport',
            name: 'metro',
            search: 'transport,train,sncf,rail',
        },
        'maki2-ranger-station': {
            font: 'fontmaki2',
            code: 59505,
            theme: 'construction',
            name: 'station',
            search: 'station,maison,ranger',
        },
        'maki2-recycling': {
            font: 'fontmaki2',
            code: 59506,
            name: 'recycling',
            search: 'recyclable,fleche',
            theme: 'service',
        },
        'maki2-religious-christian': {
            font: 'fontmaki2',
            code: 59507,
            theme: 'religion',
            name: 'christian',
            search: 'religion,chretien,coix',
        },
        'maki2-religious-jewish': {
            font: 'fontmaki2',
            code: 59508,
            theme: 'religion',
            name: 'jewish',
            search: 'religion,juif,etoile',
        },
        'maki2-religious-muslim': {
            font: 'fontmaki2',
            code: 59509,
            theme: 'religion',
            name: 'muslim',
            search: 'religion,musulman,etoile',
        },
        'maki2-residential-community': {
            font: 'fontmaki2',
            code: 59510,
            theme: 'construction',
            name: 'community',
            search: 'residentiel,immeuble,tour',
        },
        'maki2-restaurant': {
            font: 'fontmaki2',
            code: 59511,
            name: 'restaurant',
            search: 'restaurant,fourchette,couteau',
            theme: 'commerce',
        },
        'maki2-roadblock': {
            font: 'fontmaki2',
            code: 59512,
            name: 'roadblock',
            search: 'sens,interdit,panneau',
            theme: 'transport',
        },
        'maki2-rocket': { font: 'fontmaki2', code: 59513, name: 'rocket', search: 'fusee', theme: 'transport' },
        'maki2-school': {
            font: 'fontmaki2',
            code: 59514,
            name: 'school',
            search: 'education,ecole,enfant,primaire',
            theme: 'education',
        },
        'maki2-scooter': {
            font: 'fontmaki2',
            code: 59515,
            name: 'scooter',
            search: 'scooter,velo',
            theme: 'transport',
        },
        'maki2-shelter': {
            font: 'fontmaki2',
            code: 59516,
            name: 'shelter',
            search: 'barriere,pont',
            theme: 'transport',
        },
        'maki2-shoe': {
            font: 'fontmaki2',
            code: 59517,
            name: 'shoe',
            search: 'chaussure,cordonnier',
            theme: 'commerce',
        },
        'maki2-shop': { font: 'fontmaki2', code: 59518, name: 'shop', search: 'boutique,sac', theme: 'commerce' },
        'maki2-skiing': {
            font: 'fontmaki2',
            code: 59519,
            name: 'skiing',
            search: 'ski,descente,montagne',
            theme: 'sport',
        },
        'maki2-slaughterhouse': {
            font: 'fontmaki2',
            code: 59520,
            name: 'slaughterhouse',
            search: 'vache,animal,ferme,abatoire',
            theme: 'industrie',
        },
        'maki2-snowmobile': {
            font: 'fontmaki2',
            code: 59521,
            name: 'snowmobile',
            search: 'neige,ski,skido,moto',
            theme: 'transport',
        },
        'maki2-soccer': { font: 'fontmaki2', code: 59522, name: 'soccer', search: 'foot,ballon', theme: 'sport' },
        'maki2-square': { font: 'fontmaki2', code: 59523, name: 'square', search: 'carre', theme: 'forme' },
        'maki2-square-stroked': { font: 'fontmaki2', code: 59524, theme: 'forme', name: 'stroked', search: 'carre' },
        'maki2-stadium': {
            font: 'fontmaki2',
            code: 59525,
            name: 'stadium',
            search: 'stade,drapeau,chapiteau',
            theme: 'construction',
        },
        'maki2-star': { font: 'fontmaki2', code: 59526, name: 'star', search: 'etoile', theme: 'forme' },
        'maki2-star-stroked': { font: 'fontmaki2', code: 59527, theme: 'forme', name: 'stroked', search: 'etoile' },
        'maki2-suitcase': {
            font: 'fontmaki2',
            code: 59528,
            name: 'suitcase',
            search: 'valise,voyage',
            theme: 'transport',
        },
        'maki2-sushi': {
            font: 'fontmaki2',
            code: 59529,
            name: 'sushi',
            search: 'sushi,restaurant,poison',
            theme: 'commerce',
        },
        'maki2-swimming': {
            font: 'fontmaki2',
            code: 59530,
            name: 'swimming',
            search: 'eau,nage,piscine',
            theme: 'sport',
        },
        'maki2-teahouse': {
            font: 'fontmaki2',
            code: 59531,
            name: 'teahouse',
            search: 'the,salon,tasse',
            theme: 'commerce',
        },
        'maki2-telephone': {
            font: 'fontmaki2',
            code: 59532,
            name: 'telephone',
            search: 'telephone,urgence',
            theme: 'service',
        },
        'maki2-tennis': {
            font: 'fontmaki2',
            code: 59533,
            name: 'tennis',
            search: 'tennis,balle,raquette',
            theme: 'sport',
        },
        'maki2-theatre': {
            font: 'fontmaki2',
            code: 59534,
            name: 'theatre',
            search: 'theatre,culture',
            theme: 'tourisme',
        },
        'maki2-toilet': { font: 'fontmaki2', code: 59535, name: 'toilet', search: 'toilettte,wc', theme: 'service' },
        'maki2-town': { font: 'fontmaki2', code: 59536, name: 'town', search: 'ville,maisons', theme: 'construction' },
        'maki2-town-hall': {
            font: 'fontmaki2',
            code: 59537,
            theme: 'construction',
            name: 'hall',
            search: 'batiment,institution',
        },
        'maki2-triangle': { font: 'fontmaki2', code: 59538, name: 'triangle', search: 'triangle', theme: 'forme' },
        'maki2-triangle-stroked': {
            font: 'fontmaki2',
            code: 59539,
            theme: 'forme',
            name: 'stroked',
            search: 'triangle',
        },
        'maki2-veterinary': {
            font: 'fontmaki2',
            code: 59540,
            name: 'veterinary',
            search: 'animal,veterinaire,patte,empreinte',
            theme: 'commerce',
        },
        'maki2-village': {
            font: 'fontmaki2',
            code: 59541,
            name: 'village',
            search: 'village,maison',
            theme: 'construction',
        },
        'maki2-volcano': {
            font: 'fontmaki2',
            code: 59542,
            name: 'volcano',
            search: 'volcan,mont,feu',
            theme: 'paysage',
        },
        'maki2-warehouse': { font: 'fontmaki2', code: 59543, name: 'warehouse', search: 'gite', theme: 'construction' },
        'maki2-waste-basket': {
            font: 'fontmaki2',
            code: 59544,
            theme: 'service',
            name: 'basket',
            search: 'poubelle,recyclage',
        },
        'maki2-watch': {
            font: 'fontmaki2',
            code: 59545,
            name: 'watch',
            search: 'montre,bijouterie,heure',
            theme: 'commerce',
        },
        'maki2-water': { font: 'fontmaki2', code: 59546, name: 'water', search: 'eau,goutte', theme: 'forme' },
        'maki2-watermill': {
            font: 'fontmaki2',
            code: 59547,
            name: 'watermill',
            search: 'moulin,eau',
            theme: 'construction',
        },
        'maki2-wetland': {
            font: 'fontmaki2',
            code: 59548,
            name: 'wetland',
            search: 'humide,riziere,marecage',
            theme: 'paysage',
        },
        'maki2-wheelchair': {
            font: 'fontmaki2',
            code: 59549,
            name: 'wheelchair',
            search: 'handicape,roue,fauteuil,sante',
            theme: 'service',
        },
        'maki2-windmill': {
            font: 'fontmaki2',
            code: 59550,
            name: 'windmill',
            search: 'moulin,vent',
            theme: 'construction',
        },
        'maki2-zoo': { font: 'fontmaki2', code: 59551, name: 'zoo', search: 'zoo,girafe,animal', theme: 'loisir' },
    })
}

export { loadFontAwesomeDefs, loadFontAwesome5Defs, loadMakiDefs, loadMaki2Defs }
